/* eslint-disable import/prefer-default-export */
import ROLE_LEVEL from 'app/constants/RoleLevel';

const ROLE_LEVEL_LABEL = {
  USER: 'User',
  SUPER_ADMIN: 'Super Admin',
  ADMINISTRATOR: 'Adminstrator',
  SUPPORT_ADMIN: 'Support Admin',
};

export const ROLE_LEVEL_ENUM = {
  [ROLE_LEVEL.USER]: ROLE_LEVEL_LABEL.USER,
  [ROLE_LEVEL.SUPER_ADMIN]: ROLE_LEVEL_LABEL.SUPER_ADMIN,
  [ROLE_LEVEL.ADMINISTRATOR]: ROLE_LEVEL_LABEL.ADMINISTRATOR,
  [ROLE_LEVEL.SUPPORT_ADMIN]: ROLE_LEVEL_LABEL.SUPPORT_ADMIN,
  [ROLE_LEVEL_LABEL.USER]: ROLE_LEVEL.USER,
  [ROLE_LEVEL_LABEL.SUPER_ADMIN]: ROLE_LEVEL.SUPER_ADMIN,
  [ROLE_LEVEL_LABEL.ADMINISTRATOR]: ROLE_LEVEL.ADMINISTRATOR,
  [ROLE_LEVEL_LABEL.SUPPORT_ADMIN]: ROLE_LEVEL.SUPPORT_ADMIN,
};

export const DASHBOARD_CARD_STYLE = {
  borderRadius: 8,
  border: '1px solid #efefef',
  backgroundColor: '#fff',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.42), 0px 2px 2px rgba(0, 0, 0, 0.12)',
};

export const CHART_TEMPLATE = {
  id: '',
  height: '',
  width: '',
  order: '',
  filter: [],
  _key: null,
};

export const SCHEDULE_TAB = {
  TODAY: 0,
  WEEK: 1,
  MONTH: 2,
  YEAR: 3,
};

export const SCHEDULE_TAB_ENUM = {
  NOTE: 0,
  REMINEDER: 1,
  TASK: 2,
};

// Same palette as Calendar ColorPicker
export const CALENDAR_COLOURS = ['#E9776E', '#EE8A45', '#499D3F', '#0093CC', '#AB8ECC', '#757179'];

export const CALENDAR_DEFAULT_COLOUR = '#757179';

export const SCHEDULE_TYPE_COLOUR = {
  [SCHEDULE_TAB_ENUM.NOTE]: '#0093CC',
  [SCHEDULE_TAB_ENUM.REMINEDER]: '#EE8A45',
  [SCHEDULE_TAB_ENUM.TASK]: '#499D3F',
};

export const SCHEDULE_TAB_TYPE = [
  {
    label: 'Note',
    value: SCHEDULE_TAB_ENUM.NOTE,
    icon: 'description_outlined',
    colour: SCHEDULE_TYPE_COLOUR[SCHEDULE_TAB_ENUM.NOTE],
  },
  {
    label: 'Reminder',
    value: SCHEDULE_TAB_ENUM.REMINEDER,
    icon: 'notification_important_outlined',
    colour: SCHEDULE_TYPE_COLOUR[SCHEDULE_TAB_ENUM.REMINEDER],
  },
  {
    label: 'Task',
    value: SCHEDULE_TAB_ENUM.TASK,
    icon: 'format_list_bulleted_outlined',
    colour: SCHEDULE_TYPE_COLOUR[SCHEDULE_TAB_ENUM.TASK],
  },
];

export const getScheduleColour = (item) => {
  if (item?.colour) return item.colour;
  if (item?.type != null && SCHEDULE_TYPE_COLOUR[item.type]) return SCHEDULE_TYPE_COLOUR[item.type];
  return CALENDAR_DEFAULT_COLOUR;
};

export const REPEAT_ENUM = {
  DAY: 0,
  WEEK: 1,
  YEAR: 2,
};

export const REPEAT_TYPE = [
  { label: 'Day', value: REPEAT_ENUM.DAY },
  { label: 'Week', value: REPEAT_ENUM.WEEK },
  { label: 'Year', value: REPEAT_ENUM.YEAR },
];

// Mirrors OI.Domain.Enums.MedChangeHistoryState
export const MED_CHANGE_HISTORY_STATE = {
  NEW: 0,
  UPDATED: 1,
  DELETED: 2,
  CEASED: 3,
  BRAND_SWAPPED: 4,
};

export const DEFAULT_ACTIVITY_CONFIG = {
  labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_UNKNOWN',
  color: '#6F8793',
  icon: 'circle',
};

export const ACTIVITY_TYPE_CONFIG = {
  [MED_CHANGE_HISTORY_STATE.NEW]: {
    labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_NEW',
    color: '#4CAF50',
    icon: 'add',
  },
  [MED_CHANGE_HISTORY_STATE.UPDATED]: {
    labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_UPDATED',
    color: '#0B9FD9',
    icon: 'edit',
  },
  [MED_CHANGE_HISTORY_STATE.DELETED]: {
    labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_DELETED',
    color: '#FF9800',
    icon: 'delete',
  },
  [MED_CHANGE_HISTORY_STATE.CEASED]: {
    labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_CEASED',
    color: '#F44336',
    icon: 'block',
  },
  [MED_CHANGE_HISTORY_STATE.BRAND_SWAPPED]: {
    labelKey: 'dashboard:PATIENT_ACTIVITY_TYPE_BRAND_SWAPPED',
    color: '#9C27B0',
    icon: 'arrow_forward',
  },
};

export const getActivityConfig = (state) => {
  const normalizedState = Number(state);
  return ACTIVITY_TYPE_CONFIG[normalizedState] || DEFAULT_ACTIVITY_CONFIG;
};
